import React, { useCallback,useEffect, useState, useRef } from "react";
import Input from './index'

export default (props) => {
  const { extra = {} } = props;
  const { defaultValue, staticValue } = extra;

  return <Input {...props} value={defaultValue === 'static' ? staticValue : defaultValue}/>
}
